import React from "react";

const ReviewList = React.lazy(() => import('src/pages/review/ReviewList'));
const ViewReview = React.lazy(() => import('src/pages/review/ViewReview'));

const routes = [
    { path: '/dashboard/review-list/:param', withParam: true, exact: true, name: "", element: ViewReview },
    { path: '/dashboard/review-list', name: 'Reviews', element: ReviewList },
];

export default routes;
